import { TNetworks, TUsers } from 'integration/resources/newOpportunities'
import * as yup from 'yup'

import { TOption, TOptionCommon } from './OpportunitiesFilterScreen.types'

export const getOptionLabel = (option: TOption) =>
  typeof option === 'string'
    ? option
    : (option as TOptionCommon)?.name ??
      (option as TNetworks)?.network ??
      (option as TUsers)?.user_name

export const V3FiltersSchema = yup.object().shape({
  priority: yup.array(yup.string()),
  public_rating: yup.array(yup.string()),
  fidelity: yup.array(yup.string()),
  segment: yup.array(yup.string()),
  network: yup.array(yup.string()),
  subsidiary: yup.array(yup.string()),
  user_std_code: yup.array(yup.string())
})
